import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import ServicesHeroBanner from "../components/ServicesHeroBanner";
import MultpleCard from "../components/Multple-card";
import ServicesProcess from "../components/ServicesProcess";
import Choose from "../components/Choose";
import ContactForm from "../components/contact-form";
import Blog from "../components/Blog";
import servicesHeaderImage from "../images/comp/services-header-image-3.webp";
import ChooseecommerceImage from "../images/comp/choose_ecommerce _img.webp";
import researchIcon from "../images/research-icon.png";
import planningIcon from "../images/Planning.png";
import designIcon from "../images/Design.png";
import qualityIcon from "../images/Quality.png";
import developmentIcon from "../images/development.png";
import ux_icon from "../images/ux_icon.png";
import testingIcon from "../images/Testing.png";
import supportIcon from "../images/Support.png";
import launchIcon from "../images/Deployment & Launch.png";
const ECommerceDevelopmentPage = () => {
  const heroBannerData = {
    subtitle: "E-Commerce Development",
    title: "Stores That Engage. Sales That Scale.",
    description:
      "At Hope Web Solutions, we build secure, scalable, and high-converting e-commerce platforms that help businesses sell more online. Whether you're launching a new online store or optimizing an existing one, our team creates user-friendly shopping experiences tailored to your customers’ needs. From product catalog management to seamless checkout, we deliver e-commerce solutions that drive growth.",
    buttonText: "Contact now",
    buttonLink: "/contact",
    img: servicesHeaderImage,
  };
  const cardsData = [
    {
      title: "Custom API Development",
      description:
        "Designing and building secure, scalable, and high-performance APIs tailored to your unique business logic and requirements.",
      icon: researchIcon,
    },
    {
      title: "RESTful API Services",
      description:
        "Creating clean and efficient RESTful APIs that enable smooth data exchange between front-end and back-end systems.",
      icon: planningIcon,
    },
    {
      title: "Third-Party API Integration",
      description:
        "Seamless integration with popular third-party services like payment gateways, CRMs, social media platforms, and more.",
      icon: designIcon,
    },
    {
      title: "API for Mobile Applications",
      description:
        "Building lightweight, fast APIs for Android and iOS apps to ensure reliable mobile experiences.",
      icon: developmentIcon,
    },
    {
      title: "Authentication & Security",
      description:
        "Implementing secure protocols like OAuth, JWT, and API key authentication to protect your systems and data.",
      icon: qualityIcon,
    },
    {
      title: "API Documentation & Support",
      description:
        "Delivering well-documented APIs with clear endpoints, usage guidelines, and ongoing technical support.",
      icon: supportIcon,
    },
  ];

  const processData = [
    {
      title: "Business Analysis & Planning",
      description:
        "We start by analyzing your business goals, target audience, and product offerings to create a clear e-commerce strategy and roadmap.",
      icon: researchIcon,
    },
    {
      title: "Platform Selection",
      description:
        "Choosing the right e-commerce platform that matches your business needs, scalability requirements, and budget.",
      icon: designIcon,
    },
    {
      title: "UI/UX Design for Online Store",
      description:
        "Creating intuitive and visually appealing designs that enhance user engagement and conversion rates.",
      icon: developmentIcon,
    },
    {
      title: "Development & Integration",
      description:
        "Building the e-commerce platform from scratch or customizing existing platforms to meet your business requirements.",
      icon: testingIcon,
    },
    {
      title: "Testing & Launch",
      description:
        "Conducting thorough testing to ensure the platform is secure, fast, and optimized for conversions.",
      icon: qualityIcon,
    },
    {
      title: "Training & Support",
      description:
        "Providing guidance on managing the store and offering maintenance to keep it running smoothly.",
      icon: supportIcon,
    },
  ];

  const chooseData = {
    title: "Why Choose Hope Websolution?",
    image: ChooseecommerceImage,
    imageAlt: "Ui/Ux",
    items: [
      {
        label: "Plannings",
        text: "Hope Web Solutions is a leading API Development company, delivering cutting-edge digital solutions.",
      },
      {
        label: "Our Mission",
        text: "Our mission is to empower businesses with exceptional API solutions that drive growth, enhance user experience.",
      },
      {
        label: "Our Vision",
        text: "Our vision is to be a global leader in API development, recognized for our innovation, quality, and customer satisfaction.",
      },
    ],
    buttonText: "Contact now",
    buttonLink: "/contact",
  };
  return (
    <div>
      <Header />
      <ServicesHeroBanner {...heroBannerData} />
      <section className="planning-section-services">
        <div className="container">
          <div className="row align-items-center justify-content-center">
            <div className="col-lg-8 mb-4 mb-lg-0 position-relative text-center">
              <h2 className="title">E-Commerce Development Services</h2>
              <p className="sub-title text-black pt-2">
                We provide complete e-commerce solutions to help you manage
                products, boost sales, and provide exceptional shopping
                experiences.
              </p>
            </div>
          </div>
          <div className="process-grid mt-3">
            {/* 👉 Cards Loop */}
            {cardsData.map((item, index) => (
              <MultpleCard
                key={index}
                title={item.title}
                description={item.description}
                icon={item.icon}
              />
            ))}
          </div>
        </div>
      </section>
      <ServicesProcess
        title="E-Commerce Development Process"
        subtitle="Our process is designed to build e-commerce platforms that are robust, easy to manage, and conversion optimized."
        processData={processData}
      />
      <Choose {...chooseData} />
      <ContactForm />
      <Blog />
      <Footer />
    </div>
  );
};

export default ECommerceDevelopmentPage;
